import { showAlertSuccess } from "./alertActions";
import * as types from "./actionTypes";
import fileService from "../services/fileService";
import { savingUser } from "./userActions";

export function uploadFileSuccess(file) {
  return { type: types.UPLOAD_FILE_SUCCESS, file };
}

export function deleteFileSuccess(file) {
  return { type: types.DELETE_FILE_SUCCESS, file };
}

export function uploadFile(file) {
  return (dispatch) => {
    dispatch(savingUser());
    return fileService
      .uploadFile(file)
      .then((uploadedFile) => {
        dispatch(uploadFileSuccess(uploadedFile));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function deleteFile(fileUri) {
  return (dispatch) => {
    dispatch(savingUser());
    return fileService
      .deleteFile(fileUri)
      .then(() => {
        dispatch(deleteFileSuccess(fileUri));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}
